import { Icon } from "./icons-props";

const RunIcon: Icon = (props) => {
  const { width, height, color } = props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 2.47093C1 1.6855 1.86395 1.20666 2.53 1.62294L12.9765 8.15202C13.6032 8.54369 13.6032 9.45635 12.9765 9.84802L2.53 16.3771C1.86395 16.7934 1 16.3145 1 15.5291V2.47093Z"
        stroke="#4B1583"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default RunIcon;
